import { useState } from 'react'
import Modal from '../../../../components/modal/Modal'
import { Icon } from '@iconify/react'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import FormLoader from '../../../../components/loader/FormLoader'
import './CustomerModals.scss'

function CreateUser({ fetchCustomers, close }: any) {
  const { notify } = useGlobalContext()
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [emailInput, setEmailInput] = useState('')
  const [username, setUsername] = useState('')
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false)

  const createAdmin = async () => {
    const emptyFields = []
    if (!firstName) emptyFields.push('First Name')
    if (!lastName) emptyFields.push('Last Name')
    if (!emailInput) emptyFields.push('Email')
    if (!username) emptyFields.push('Username')
    if (!phone) emptyFields.push('Phone Number')
    if (emptyFields.length > 0) {
      notify(
        'warn',
        `The following fields are required: ${emptyFields.join(', ')}`
      )
      return
    }

    const data = {
      firstname: firstName,
      lastname: lastName,
      email: emailInput.toLowerCase(),
      username: username,
      phonenumber: phone,
    }
    setLoading(true)
    post(`admin/create-user`, data, null)
      .then((result: any) => {
        if (result.status === 201) {
          notify('success', result.message)
          close()
          fetchCustomers(1)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Modal>
      <div className='customer-side-modal'>
        <div className='side-modal-header'>
          <div className='header-left'>
            <div className='header-icon'>
              <Icon icon='mdi:account-plus-outline' />
            </div>
            <h2>Create User</h2>
          </div>
          <div className='close-btn' onClick={() => close()}>
            <Icon icon='line-md:close' />
          </div>
        </div>

        <div className='form-group'>
          <label>First Name</label>
          <input
            type='text'
            placeholder='Enter first name'
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>

        <div className='form-group'>
          <label>Last Name</label>
          <input
            type='text'
            placeholder='Enter last name'
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        <div className='form-group'>
          <label>Email Address</label>
          <input
            type='email'
            placeholder='Enter email address'
            value={emailInput}
            onChange={(e) => setEmailInput(e.target.value)}
          />
        </div>

        <div className='form-group'>
          <label>Username</label>
          <input
            type='text'
            placeholder='Enter username'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className='form-group'>
          <label>Phone Number</label>
          <input
            type='tel'
            placeholder='Enter phone number'
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <button className='submit-btn' onClick={createAdmin}>
            Create User
          </button>
        )}
      </div>
    </Modal>
  )
}

export default CreateUser
